<template>
    <div class="mb-2">
    <!-- <v-toolbar class="header-release" elevation="0">
      <v-toolbar-title> -->
    <span :class="{ 'color-header': $utilFront.isDarkTheme(), 'color-sitd-dark': !$utilFront.isDarkTheme() }">
      {{ title }} 
          <v-icon medium right>{{ elementos.icono }}</v-icon>
    </span>
    <!-- </v-toolbar-title> -->
    <!-- <v-spacer></v-spacer>
    </v-toolbar> -->
    <!-- <div class="separator"></div> -->
  </div>
    <!-- <v-toolbar
      style="border-top: 3px solid #59805c !important; border-radius: 8px !important;"
      elevation="0"
    >
      <v-toolbar-title>
        <span
          :class="{
            'color-sitd': $utilFront.isDarkTheme(),
            'color-sitd-dark': !$utilFront.isDarkTheme(),
          }"
        >
          {{ title }}
        </span>
        <span>
          <v-icon medium right :class="{
            'color-sitd': $utilFront.isDarkTheme(),
            'color-sitd-dark': !$utilFront.isDarkTheme(),
          }">{{ elementos.icono }}</v-icon>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="separator20-50"></div> -->
</template>
<script>
export default {
  name: "Titulo",
  props: {
    elementos: Object,
    action: Number,
    isViewDetailsForm: Boolean
  },
  created() {
    this.updateTitle();
  },
  watch: {
    action() {
      this.updateTitle();
    },
  },
  data() {
    return {
      title: "Administración",
    };
  },
  methods: {
    updateTitle() {
      switch (this.action) {
        case 1:
          this.title = this.elementos.texto;
          break;
        case 2:
          this.title = this.elementos.textNew;
          break;
        case 3:
          if(this.isViewDetailsForm === true){
            this.title = this.elementos.textView ||  this.elementos.textEdit;
          }else{
            this.title = this.elementos.textEdit ||  this.elementos.textView;
          }
          
          break;
        default:
          this.title = this.elementos.texto;
          break;
      }
    },
  },
};
</script>
<style scoped></style>
